import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
    SortingState, SelectionState, FilteringState, PagingState, RowDetailState,
    IntegratedFiltering, IntegratedPaging, IntegratedSorting, IntegratedSelection,
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    TableHeaderRow, TableRowDetail, TableFilterRow, TableSelection, TableColumnResizing,
    PagingPanel,
    Toolbar,
} from '@devexpress/dx-react-grid-material-ui';

// Material components
import {
    Paper,
} from '@material-ui/core';

import {
    DateTimeTypeProvider,
    FilterCellComponent,
    FilterIcon,
    filtersMessages,
    filteringColumnExtensions
} from '../shared/custom-grid-items/DataFormatters';

import {
    DetailsRowLogOperations
} from '../shared/custom-grid-items/DetailsRowLogOperations';

import CustomActionsState from '../shared/custom-grid-items/CustomActionsState';
import CustomActions from '../shared/custom-grid-items/CustomActions';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    detailContainer: {
        margin: '10px',
    },
    paperMain: {
        padding: '10px',
        textAlign: 'right',
        minHeight: "450px",
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
});


class GridLogLicenzeCmp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: [
                { name: 'ID', title: 'ID log' },
                { name: 'SerialNumber', title: 'S/N' },
                { name: 'ProductKey', title: 'Product Key' },
                { name: 'DataOperation', title: 'Data operazione' },
                { name: 'CodiceUtente', title: 'Codice Utente' },
            ]
        };

        this.onSelectionChange = this.onSelectionChange.bind(this);

    }

    componentDidUpdate(propsPrecedenti) {
        if (this.props.selectedRowIndex !== propsPrecedenti.selectedRowIndex) {
            if (this.props.selectedRowIndex === -1)
                this.props.setSelectedLogLicenza({});
            else
                this.props.setSelectedLogLicenza(this.props.log_licenze[this.props.selectedRowIndex]);
        }
    }

    onSelectionChange(newSelection) {

        this.props.handleRowSelection(newSelection);

    }

    render() {
        const { classes, getLogLicenze, resetFilters, codiceUtente } = this.props;

        return (
            <Paper className={classes.paperMain}>
                <Grid
                    rows={this.props.log_licenze}
                    columns={this.state.columns}
                >
                    <DateTimeTypeProvider for={['DataOperation']} />

                    <FilteringState
                        filters={this.props.filters}
                        onFiltersChange={filters => this.props.onFiltersChange(filters)}
                    />

                    <SortingState
                        sorting={this.props.sorting}
                        onSortingChange={sorting => this.props.onSortingChange(sorting)}
                    />

                    <PagingState
                        currentPage={this.props.currentPage}
                        onCurrentPageChange={currentPage => this.props.onCurrentPageChange(currentPage)}
                        pageSize={this.props.pageSize}
                        onPageSizeChange={pageSize => this.props.onPageSizeChange(pageSize)}
                    />

                    <SelectionState
                        selection={this.props.selection}
                        onSelectionChange={this.onSelectionChange}
                    />

                    <RowDetailState
                        expandedRowIds={this.props.expandedRowIds}
                        onExpandedRowIdsChange={expandedRowIds => this.props.handleExpandedRow(expandedRowIds)}
                    />

                    <IntegratedFiltering columnExtensions={filteringColumnExtensions} />
                    <IntegratedSorting />
                    <IntegratedPaging />
                    <IntegratedSelection />

                    <Table />

                    <TableColumnResizing
                        columnWidths={this.props.columnWidths}
                        onColumnWidthsChange={widths => this.props.onColumnWidthsChange(widths)}
                    />

                    <TableSelection
                        highlightRow
                        selectByRowClick
                        showSelectionColumn={false}
                    />

                    <TableFilterRow cellComponent={FilterCellComponent}
                        showFilterSelector
                        iconComponent={FilterIcon}
                        messages={filtersMessages}
                    />

                    <TableHeaderRow showSortingControls />

                    <TableRowDetail contentComponent={DetailsRowLogOperations} />

                    <CustomActionsState
                        onRefreshClick={() => getLogLicenze(codiceUtente)}
                        onResetClick={() => resetFilters()}
                    />

                    <Toolbar />
                    <CustomActions />


                    <PagingPanel pageSizes={this.props.pageSizes} />

                </Grid>
            </Paper>
        );

    }
}

GridLogLicenzeCmp.propTypes = {
    getLogLicenze: PropTypes.func.isRequired,
    getLogLicenzeRequestStatus: PropTypes.string.isRequired,
    log_licenze: PropTypes.arrayOf(PropTypes.object).isRequired,

    setSelectedLogLicenza: PropTypes.func.isRequired,

    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(GridLogLicenzeCmp);